import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { IFootNote, PositionEnum, SdFootnoteComponent } from '@seb/web-design-system/core';
import { AbstractComponent } from '../abstract-component.component';
import { FootnoteComponentInterface } from '../../../models';
import { FootnoteTextConfigEnum } from '../../../enums';

@Component({
  selector: 'wc-footnote',
  templateUrl: './footnote.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdFootnoteComponent]
})
export class FootnoteComponent extends AbstractComponent<FootnoteComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  textConfig: PositionEnum;
  footnote: IFootNote[];

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.subscribe((cmp: FootnoteComponentInterface) => {
        this.footnote = this.toFootnote(cmp);
        this.textConfig = this.mapTextConfig(cmp.textConfig);
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  override mandatoryFunction = (cmp: FootnoteComponentInterface): boolean => {
    return !!cmp.content;
  };

  private toFootnote(cmp: FootnoteComponentInterface): IFootNote[] {
    return [{ note: cmp.content, id: cmp.uid }];
  }

  private mapTextConfig(textConfig: FootnoteTextConfigEnum): PositionEnum {
    switch (textConfig) {
      case FootnoteTextConfigEnum.LEFT:
        return PositionEnum.left;
      case FootnoteTextConfigEnum.CENTER:
        return PositionEnum.center;
      case FootnoteTextConfigEnum.RIGHT:
        return PositionEnum.right;
      default:
        return PositionEnum.left;
    }
  }
}
